import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { Fragment } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faSpinner } from '@fortawesome/free-solid-svg-icons'
const NotificationSlideOut = ({ open, setOpen, message }) => {
  const axios = useAxiosPrivate()
  const { auth, setShowLoader } = useAuth()
  const [replies, setReplies] = useState([])
  const [lastReply, setLastReply] = useState([])
  const [replyText, setReplyText] = useState('')
  const [isSending, setIsSending] = useState(false)
  const [loadThreads, setLoadThreads] = useState(false)

  useEffect(() => {
    if (message?.id) {
      getUserThread(message.id)
    }
  }, [message?.id])

  const getUserThread = async (id) => {
    try {
      setLoadThreads(true)
      const response = await axios.get('/notifications/user-thread/' + id)
      const { thread, replies, last_replied } = response.data.result
      setReplies(replies)
      setLastReply(last_replied)
    } catch (error) {
      console.error(error)
    }
    setLoadThreads(false)
  }

  const handleSendReply = async () => {
    if (!replyText.trim()) return
  
    try {  
      const targetUserId = lastReply?.created_by
  
      const payload = {
        title: message.title,
        body: replyText,
        type: 'System Update',
        area: 'Dashboard',
        user_id: auth.user.id,
        practitionerIds: targetUserId ? [targetUserId] : [],
        meta: {
          ...message?.meta,
        },
      }
  
      setIsSending(true)
  
      const response = await axios.post('/notifications/create', payload)
  
      if (response.data?.result) {
        setReplies([...replies, response.data.result])
        setReplyText('')
      }
    } catch (error) {
      console.error('Failed to send reply:', error)
    } finally {
      setIsSending(false)
    }
  }
  
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative" onClose={setOpen} style={{zIndex: 999}}>
        <Transition
          as={Fragment}
          show={open}
          enter="ease-in-out duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-75"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition
                as={Fragment}
                show={open}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <DialogPanel className="pointer-events-auto w-screen max-w-2xl">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                    <div className="bg-blue-500 px-4 py-6 sm:px-6">
                      <div className="flex items-center justify-between">
                        <DialogTitle className="text-base leading-6 text-white">Message Thread: <span className=' font-semibold'>{ message?.title ?? ''}</span></DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="relative rounded-md bg-blue-500 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            onClick={() => {
                              setOpen(false)
                              setReplies([])
                              setLastReply([])
                              setReplyText('')
                            }}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-4 flex-1 px-4 sm:px-6">
                      <div className='flex justify-end'>
                        <Link to={`/clients/${message?.meta?.client_id}`}>
                          <span className="flex justify-center items-center bg-blue-400 rounded-md text-white px-4 py-2 hover:bg-blue-500 cursor-pointer text-xs">
                            View Client
                          </span>
                        </Link>
                      </div>
                      <div className='relative'>
                          <div className="text-sm font-semibold text-gray-700 mb-2">Current Message:</div>
                          <div className="space-y-4">
                            <div className="p-4 border rounded-md bg-gray-50">
                              <div className="text-sm text-slate-700 whitespace-pre-line">{message?.body}</div>

                              <div className="text-xs text-gray-500 mt-2">
                                From: <span className="font-medium">{message?.created || 'Unknown User'}</span><br />
                                Sent: {moment(message?.created_at).format('DD/MM/YYYY [at] HH:mm')}
                              </div>
                            </div>
                          </div>
                        </div>
                        {loadThreads ? (
                          <FontAwesomeIcon icon={faSpinner} spin className="text-blue-500 h-10 w-10 absolute top-1/2 left-1/2" />
                          ) : (
                           <>
                            {replies?.length > 0 && (
                              <div className="mt-4 border-t pt-4">
                                <div className="text-sm font-semibold text-gray-700 mb-2">Message Thread:</div>
                              
                                <div className="space-y-3">
                                  {replies.map((reply, index) => {
                                    const isCurrentUser = reply.created_by === auth?.user?.id
                                    const isFirstMessage = index === 0
                                    return (
                                      <div
                                        key={index}
                                        className={`max-w-[80%] p-4 rounded-lg border text-sm shadow ${
                                          isCurrentUser
                                            ? 'ml-auto bg-blue-100 border-blue-300 text-left'
                                            : 'mr-auto bg-gray-100 border-gray-300 text-left'
                                        }`}
                                      >
                                        {isFirstMessage && reply?.title && (
                                          <div className="text-sm font-semibold text-gray-800 mb-2">
                                            {reply?.title ?? ''}
                                          </div>
                                        )}
                                        <div className="text-slate-700 whitespace-pre-line">{reply?.body}</div>
                                        <div className="text-xs text-gray-500 mt-2">
                                          From: <span className="font-medium">{reply.created || 'Unknown User'}</span><br />
                                          Sent: {moment(reply.created_at).format('DD/MM/YYYY [at] HH:mm')}
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                           </>
                          )}
                    </div>
                    <div className="sticky bottom-0 bg-white border-t p-4">
                      <div className="flex items-end space-x-2">
                        <textarea
                          className="border rounded-md w-full p-2"
                          rows="2"
                          value={replyText}
                          onChange={(e) => setReplyText(e.target.value)}
                          placeholder="Write your reply..."
                        />
                        <button
                          onClick={handleSendReply}
                          disabled={isSending}
                          className={`px-4 py-2 rounded-md text-white flex items-center justify-center min-w-[80px] ${
                            isSending ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                          }`}
                        >
                          {isSending ? (
                            <FontAwesomeIcon icon={faSpinner} spin className="text-blue-500 h-5 w-5" />
                          ) : (
                            'Send'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </Transition>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default NotificationSlideOut
